import { formatDateString } from "@/lib/utils";
import { UserFacingError } from "@/models/helper/UserFacingError";
import { AvailableShiftsResponse } from "@/models/shift/AvailableShiftsResponse";
import axios from "axios";

export default class ShiftService {
  static async getAvailableShifts(
    date: Date,
    roomId: string,
    roomCode: string,
    roomTypeId?: string,
    roomLocationId?: string,
  ): Promise<AvailableShiftsResponse> {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_URL}shift/available`,
        {
          params: {
            date: formatDateString(date.toISOString()),
            room_id: roomId,
            room_code: roomCode,
            room_type_id: roomTypeId,
            room_location_id: roomLocationId,
          },
          withCredentials: true,
        },
      );
      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch Error.",
        description:
          "Failed to fetch available shifts. Please try again later.",
      });
    }
  }

  static async getRoomTransactions(
    date: Date,
    roomId: string,
    roomCode: string,
    roomTypeId?: string,
  ): Promise<AvailableShiftsResponse> {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_URL}shift/transactions`,
        {
          params: {
            date: formatDateString(date.toISOString()),
            room_id: roomId,
            room_code: roomCode,
            room_type_id: roomTypeId,
          },
          withCredentials: true,
        },
      );
      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch Error.",
        description:
          "Failed to fetch room transactions. Please try again later.",
      });
    }
  }

  static async getAllHoliday(year: string): Promise<Date[]> {
    const res = await axios.get(
      `${import.meta.env.VITE_API_URL}shift/holiday?year=${year}`,
    );

    return res.data.data.map(
      (holiday: { TheDate: string }) => new Date(holiday.TheDate),
    );
  }
}
